import React from 'react';
import { Info, Server, Cloud, Globe2, Code2, Box, Monitor } from 'lucide-react';

interface KeyInfo {
  parentDomain?: string;
  ipAddress?: string;
  hosting?: string;
  region?: string;
  technology?: string;
  framework?: string;
  webServer?: string;
  asn?: string;
  cdnName?: string;
  country?: string;
  org?: string;
  wafName?: string;
  city?: string;
  loc?: string;
}

interface AssetKeyInfoProps {
  data: KeyInfo;
}

export const AssetKeyInfo: React.FC<AssetKeyInfoProps> = ({ data }) => {
  return (
    <div className="bg-[#0F1629] rounded-xl p-6 border border-gray-800/50">
      <div className="flex items-center space-x-2 mb-4">
        <Info className="h-5 w-5 text-blue-500" />
        <h2 className="text-lg font-semibold text-white">Key Information</h2>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-4">
          <div className="flex items-start space-x-3">
            <div className="p-2 rounded-lg bg-gray-800/30">
              <Globe2 className="h-4 w-4 text-blue-500" />
            </div>
            <div>
              <div className="text-sm text-gray-400">ASN</div>
              <div className="text-sm font-medium text-white mt-0.5">{data.asn || 'Unknown'}</div>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <div className="p-2 rounded-lg bg-gray-800/30">
              <Server className="h-4 w-4 text-purple-500" />
            </div>
            <div>
              <div className="text-sm text-gray-400">CDN</div>
              <div className="text-sm font-medium text-white mt-0.5">{data.cdnName || 'Unknown'}</div>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <div className="p-2 rounded-lg bg-gray-800/30">
              <Cloud className="h-4 w-4 text-emerald-500" />
            </div>
            <div>
              <div className="text-sm text-gray-400">Country</div>
              <div className="text-sm font-medium text-white mt-0.5">{data.country || 'Unknown'}</div>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <div className="p-2 rounded-lg bg-gray-800/30">
              <Globe2 className="h-4 w-4 text-yellow-500" />
            </div>
            <div>
              <div className="text-sm text-gray-400">Region</div>
              <div className="text-sm font-medium text-white mt-0.5">{data.region || 'Unknown'}</div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div className="flex items-start space-x-3">
            <div className="p-2 rounded-lg bg-gray-800/30">
              <Code2 className="h-4 w-4 text-blue-500" />
            </div>
            <div>
              <div className="text-sm text-gray-400">Organization</div>
              <div className="text-sm font-medium text-white mt-0.5">{data.org || 'Unknown'}</div>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <div className="p-2 rounded-lg bg-gray-800/30">
              <Box className="h-4 w-4 text-purple-500" />
            </div>
            <div>
              <div className="text-sm text-gray-400">WAF</div>
              <div className="text-sm font-medium text-white mt-0.5">{data.wafName || 'Unknown'}</div>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <div className="p-2 rounded-lg bg-gray-800/30">
              <Monitor className="h-4 w-4 text-emerald-500" />
            </div>
            <div>
              <div className="text-sm text-gray-400">City</div>
              <div className="text-sm font-medium text-white mt-0.5">{data.city || 'Unknown'}</div>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <div className="p-2 rounded-lg bg-gray-800/30">
              <Monitor className="h-4 w-4 text-emerald-500" />
            </div>
            <div>
              <div className="text-sm text-gray-400">Location</div>
              <div className="text-sm font-medium text-white mt-0.5">{data.loc || 'Unknown'}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};